// extracted by mini-css-extract-plugin
module.exports = {"FarmSelect":"FarmSelect--1dQt_","Icon":"Icon--154Xh"};